import script from "./SignaturePad.vue?vue&type=script&setup=true&lang=js"
export * from "./SignaturePad.vue?vue&type=script&setup=true&lang=js"

import "./SignaturePad.vue?vue&type=style&index=0&id=1c0340a5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c0340a5"]])

export default __exports__